import http from "@/http";
import { ACOMPANHAMENTO_ENDPOINTS } from "../constantes/endpoints";

class QuestionarioService {
  async iniciarQuestionario(cdCooperado, cdProced) {
    try {
      const endpoint = ACOMPANHAMENTO_ENDPOINTS.INICIAR_QUESTIONARIO;
      const response = await http.post(endpoint, {
        cdCooperado,
        cdProced
      });

      return {
        success: response.data?.sucesso || response.data?.success || true,
        data: response.data?.data || response.data,
        error: response.data?.erro
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        statusCode: error.response?.status
      };
    }
  }

  async retomarQuestionario(cdCooperado, cdProced) {
    try {
      const endpoint = ACOMPANHAMENTO_ENDPOINTS.RETOMAR_QUESTIONARIO;
      const response = await http.post(endpoint, {
        cdCooperado,
        cdProced
      });

      return {
        success: response.data?.sucesso || response.data?.success || true,
        data: response.data?.data || response.data,
        error: response.data?.erro
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.message,
        statusCode: error.response?.status
      };
    }
  }

  async responderQuestionario(payload) {
    try {
      const endpoint = ACOMPANHAMENTO_ENDPOINTS.RESPONDER_QUESTIONARIO;
      const response = await http.post(endpoint, payload);

      return {
        success: response.data?.sucesso || response.data?.success || true,
        mensagem: response.data?.mensagem || "Respostas enviadas com sucesso",
        data: response.data?.data || response.data?.pergunta || null
      };
    } catch (error) {
      const responseData = error.response?.data;
      const statusCode = error.response?.status;
      const validationErrors = responseData?.errors
        ? Object.values(responseData.errors)
            .flat()
            .join(" ")
        : "";

      return {
        success: false,
        statusCode,
        error: validationErrors || responseData?.message || error.message
      };
    }
  }

  async voltarQuestionario(payload) {
    try {
      const endpoint = ACOMPANHAMENTO_ENDPOINTS.VOLTAR_QUESTIONARIO;
      const response = await http.post(endpoint, payload);

      return {
        success: response.data?.sucesso || response.data?.success || true,
        mensagem:
          response.data?.mensagem || "Voltando para a pergunta anterior",
        data: response.data?.data || response.data?.pergunta || null
      };
    } catch (error) {
      const responseData = error.response?.data;
      const validationErrors = responseData?.errors
        ? Object.values(responseData.errors)
            .flat()
            .join(" ")
        : "";

      return {
        success: false,
        error: validationErrors || responseData?.message || error.message
      };
    }
  }

  async finalizarQuestionario(payload) {
    try {
      const endpoint = ACOMPANHAMENTO_ENDPOINTS.FINALIZAR_QUESTIONARIO;
      const response = await http.post(endpoint, payload);

      return {
        success: response.data?.sucesso || response.data?.success || true,
        mensagem: response.data?.mensagem,
        data: response.data?.data || response.data?.pergunta || null
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
}

export const questionarioService = new QuestionarioService();
